import { Api } from '@cui/req'
// import { apiPrefix } from './consts'
import { GetPageLowCodeType, GetTaskPageType, GetRecordListType } from './type'

export function buiApi(config: any) {
  return Api({
    ...config,
    headers: {
      ...config?.headers,
      ...buiApi.headers,
    },
  });
}

// 任务页面
export const getTaskPage: GetTaskPageType = async ({ taskId }) => {
  return Api({
    url: `/api/gateway/metabase/compose/task/template/${taskId}`,
    method: 'GET',
  })
}

// 获取场景配置页
export const getPageLowCode: GetPageLowCodeType = async ({ pageStatus, pageKey }) => {
  const data = {
    condition: 'page_status=${page_status} AND unique_config_key=${unique_config_key}',
    pageNum: 1,
    pageSize: 100,
    parameters: {
      page_status: pageStatus,
      unique_config_key: pageKey,
    }
  }
  return Api({
    url: '/api/gateway/metabase/api/v1/tech/page_structure_config/page',
    method: 'POST',
    data,
  })
}

export async function getTaskPropertySettings({ pageNum = 1, pageSize = 100, taskId, logicEntityId }: any): Promise<any> {
  const [err, res] = await Api({
    method: 'post',
    url: `/api/gateway/metabase/api/v1/tech/scene_activity_task_logic_entity_property/page`,
    data: {
      condition: taskId ? 'task_id = ${taskId} AND  logic_entity_id = ${logicEntityId}' : '',
      sort: 'sequence+',
      pageNum,
      pageSize,
      parameters: { taskId, logicEntityId },
    },
  });
  return res?.data || {};
}

// 获取行数据
export const getRecordList: GetRecordListType = async ({ moduleID, namespaceID, filter }) => {
  const data = {
    filter,
    limit: 1000,
    moduleID,
    namespaceID,
    page: 1,
  }
  return Api({
    url: `/api/gateway/metabase/compose/namespace/${namespaceID}/module/${moduleID}/record/listRecords`,
    method: 'POST',
    data,
  })
}

export const getMainData = async ({
  brandType = '',
  brandCode = '',
  productCode,
}: any) => {
  brandType = brandType || '';
  brandCode = brandCode || '';
  const searchParams: any = {
    app_id: 'master_data',
    model_id: 'md_bbom_template',
    bd_bpart_product_classification_number: productCode,
  };
  // if (brandType) {
  //   searchParams.bd_brand_classification_type_code = brandType;
  // }
  // if (brandCode) {
  //   searchParams.bd_brand_classification_number = brandCode;
  // }
  const res = await postRecordList(searchParams);
  // const mainData = (res?.data || []).find((item: any) => {
  //   return item.bd_brand_classification_type_code === brandType && item.bd_brand_classification_number === brandCode;
  // });
  const mainData = res?.data?.[0];
  return mainData;
};

export async function postRecordList({
  pageNum = 1,
  pageSize = 1000,
  app_id = 'base',
  model_id,
  conditionType = '=',
  ...others }: any): Promise<any> {
  const keys = Object.keys(others).filter((key: string) => key);
  let str = '';
  if (conditionType === '=') {
    str = keys.map((key: string) => `${key} ${conditionType} \${${key}} `).join(' AND ');
  } else {
    str = keys.map((key: string) => `${key} ${conditionType} '%\${${key}}%' `).join(' AND ');
  }
  const [err, res] = await Api({
    method: 'post',
    url: `/api/gateway/metabase/api/v1/${app_id}/${model_id}/page`,
    data: {
      condition: keys.length > 0 ? str : '',
      pageNum,
      pageSize,
      parameters: others,
    },
  });
  return res?.data || {};
}

// 需求匹配接口
export const productDemandMatch = async (data: any) => {
  const [err, res] = await Api({
    url: '/api/demand-match/model/NPI_product_demand_match',
    method: 'POST',
    data,
  })
  return res?.data || {};
}

// 基础数据模型对应recordList通用请求接口
export const getBaseRecordList = async ({
  model_id,
  data,
  appId
}: any) => {
  return Api({
    url: `/api/gateway/metabase/api/v1/${appId || 'base'}/${model_id}/page`,
    method: 'POST',
    data,
  })
}

export async function createBatch(data: any) {
  const [err, res] = await Api({
    method: 'post',
    url: `/api/gateway/metabase/serviceFlow/api/compose_batch_create`,
    data,
  });
  return res?.data || {};
}

export async function updateBatch(data: any) {
  (buiApi as any).headers = { taskId: 'TASK20221219105056929797' };
  const [err, res] = await buiApi({
    method: 'post',
    url: `/api/gateway/metabase/serviceFlow/api/compose_batch_operation_records`,
    data,
  });
  return res?.data || {};
}

export async function getRecordById({ model_id, app_id, record_id }: any) {
  return Api({
    method: 'get',
    url: `/api/gateway/metabase/compose/namespace/${app_id}/module/${model_id}/record/${record_id}`,
  });
}

export async function getSortList(data: any) {
  const [err, res] = await Api({
    method: 'get',
    url: `/api/gateway/workspaceservice/workspace/classification/categroy/tree/whole`,
    params: data,
  });
  return res?.data || [];
}

export async function searchMainDataList(data: any) {
  const [err, res] = await Api({
    method: 'post',
    url: `/api/gateway/workspaceservice/workspace/classification/searchMainDataList`,
    data,
  });
  return res?.data || [];
}

export async function searchCascade(data: any) {
  const [err, res] = await Api({
    method: 'get',
    url: `/api/gateway/workspaceservice/workspace/business/searchEnums`,
    params: data,
  });
  const result = turnCascadeTree(res.data.relationship?.[0]?.enumValueNodes || []);
  return result;
}

function turnCascadeTree(data: any) {
  const defaultVaule = []
  const res = data.map(item => {
    if (item.default) {
      defaultVaule.push(item.value)
      // eslint-disable-next-line
      const defaultItem = item.mountEnumTypes[0]?.enumValueNodes.find($item => $item.default)
      defaultVaule.push(defaultItem ? defaultItem.value : item.mountEnumTypes[0]?.enumValueNodes?.[0]?.value);
      // item.mountEnumTypes[0]?.enumValueNodes.forEach($item => {
      //   if ($item.default) {
      //     defaultVaule.push($item.value)
      //   }
      // })
    }
    return {
      ...item,
      label: item.displayLabel,
      children: item.mountEnumTypes?.[0]?.enumValueNodes.map(it => {
        return {
          ...it,
          label: it.displayLabel,
        }
      }) || [],
    }
  })
  return { defaultVaule, res }
}